import { render, staticRenderFns } from "./ResellerInvoiceViewGlobal.vue?vue&type=template&id=141f54e6"
import script from "./ResellerInvoiceViewGlobal.vue?vue&type=script&lang=js"
export * from "./ResellerInvoiceViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports